import {Avatar, CardHeader} from '@mui/material';
import {CellProps} from '..';

export const ResponsibleCell = ({task, professionals}: CellProps) => {
  let picture = '';
  let name = '';
  const handledByUserId = task.careTask.markedAsHandledByUserId;

  if (handledByUserId) {
    picture = professionals[handledByUserId]?.picture || '';
    name = professionals[handledByUserId]?.name || '';
  }

  return (
    <span>
      {name && (
        <CardHeader
          avatar={
            <Avatar
              sx={{
                width: '22px',
                height: '22px',
              }}
              src={picture}
            />
          }
          title={name}
          sx={{
            height: '20px',
            padding: 0,
            justifyContent: 'flex-start',
            gap: '4px',
            '& .MuiCardHeader-content': {
              flexGrow: 0,
            },
            '& .MuiCardHeader-avatar': {
              margin: 0,
            },
            '& .MuiCardHeader-title': {
              fontSize: '16px',
              fontWeight: 500,
              lineHeight: '19px',
              letterSpacing: '0.25px',
              textAlign: 'left',
              color: 'var(--dcm-gray)',
            },
          }}
        />
      )}
    </span>
  );
};
